import { CreateRequestForExternalFlightState } from './createRequestForExternalFlight.types'

const initialState: CreateRequestForExternalFlightState = {
  loading: false,
  error: null,
  success: null
}

export default initialState
